import './form-card-category.scss';

import { CardCategoryFormSchema } from "@factory/form/form.rule";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputTextareaControl from '@shared/ui/hook-form/input-textarea-control/input-textarea-control';
import { useFormContext } from "react-hook-form";

type InputFormSchema = CardCategoryFormSchema;
export function FormCardCategory() {
  const { control } = useFormContext<CardCategoryFormSchema>();
  return (
    <div id="FormCardCategory" className="card-category">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="expirationYears"
        label="Expiration Years"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter expirationYears"
      />
    </div>
  );
}

export default FormCardCategory;